import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from './index.module.scss'
import { useQueryDealRecord } from "./hooks/useTransactionRecords";
import DateFilter from "../betOrderRecords/compoments/dateFilter";
import VenueFilter from "../betOrderRecords/compoments/venueFilter";
import LoadingUI from "@/compoments/loadingUI";
import TransactionList from "./compoments/transactionList";
import PaginationTo from "../betOrderRecords/compoments/paginationTo";
import FadeIn from "@/compoments/fadeIn";
import { useTranslation } from "react-i18next";

export type Filter = {
  queryType: number;
  page: {
    start_at: string;
    end_at: string;
    pageNum: number;
    pageSize: number;
  };
  _refresh?: number; 
};

const TransactionRecords = () => {
  const { t } = useTranslation('record')

  // queryType 1:存款 2:提款 3:转账 4:红利 5:反水 6:加币(上分) 7:减币(下分) 8:调整 9:其他 10:买料 14:礼物 15:合买
  const venueOptions = [
    {label: t('deposit'), value: 1},
    {label: t('withdrawal'), value: 2},
    {label: t('transfer'), value: 3},
    {label: t('bonus'), value: 4},
    {label: t('rebate'), value: 5},
    {label: t('credit'), value: 6},
    {label: t('debit'), value: 7},
    {label: t('adjustment'), value: 8},
    {label: t('other'), value: 9},
  ] 
 
  // 初始筛选条件
  const getFilters = () => ({
    queryType: 1, // 存款(选项)
    page: {
      start_at: ut.getDateString(0), // 开始日期今天
      end_at: ut.getDateString(0), // 结束日期
      pageNum: 1,  // 当前页码
      pageSize: 5, // 每页记录数
    }
  })
  // 状态管理更新筛选条件
  const initialFilters = getFilters()
  const [filterInputs, setFilterInputs] = useState<Filter>(initialFilters)
  const [filters, setFilters] = useState<Filter>(initialFilters)

  // 点击查询按钮后：更新过滤条件并重置为第一页
  const handleSearch = () => {
    setFilters({ 
      ...filterInputs, 
      page: {
        ...filterInputs.page,
        pageNum: 1,
      },
      _refresh: Date.now(), //确保 filters 总是“新对象”
    });
  };

   // 获取交易记录
  const { list, totalPage, totalRecord, isLoading } = useQueryDealRecord(filters)

  // 加入真实高度缓存逻辑
  const contentRef = useRef<HTMLDivElement>(null)
  const [contentHeight, setContentHeight] = useState<number | undefined>()
  useEffect(() => {
    if (!isLoading  && contentRef.current) {
      const height = contentRef.current.getBoundingClientRect().height
      setContentHeight(height)
    }
  }, [isLoading, list])
  
  return (
    <FadeIn>
    <div className={styles.transactionRecords}>
      <div className={styles.title}>{t('transactionRecord')}</div>

      {/* 日期筛选 */}
      <DateFilter
        value={{startAt: filters.page.start_at, endAt: filters.page.end_at}}
        onChange={(start, end) =>
          setFilters(prev => ({
            ...prev,
            page: {
              ...prev.page,
              start_at: start,
              end_at: end,
            },
            _refresh: Date.now(), // 总是刷新
          }))
        }
      />

      <div className={styles.venue}>
        {/* 筛选 */}
        <VenueFilter
          value={{venueId: filterInputs.queryType}}
          venueOptions={venueOptions}
          onChange={(venueId) => setFilterInputs(prev => ({ ...prev, queryType: venueId }))}
        />
        {/* 查询按钮 */}
        <button onClick={handleSearch}>{t('query')}</button>
      </div>
      
      <LoadingUI data={ list } loading={isLoading} height={contentHeight}>
        <div ref={contentRef}>
          {/* 交易记录列表 */}
          <TransactionList lists={list} />
        </div>
      </LoadingUI>
      
      {/* 分页器 */}
      {totalRecord > 0 && <PaginationTo 
        current={filters.page.pageNum}
        total={totalRecord}
        pageSize={filters.page.pageSize}
        onChange={(page) => {
          setFilters(prev => ({ 
            ...prev, 
            page: {
              ...prev.page,
              pageNum: page,
            },
          }));
        }}
      />}
    </div>
    </FadeIn>
  )
}

export default TransactionRecords